export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  // Don't load tracker in development mode
  if (
    config.public.IS_DEVELOPMENT ||
    !config.public.ADVERTISER_USER_TRACKER_APP_INSIGHTS_KEY
  ) {
    return;
  }

  const script = document.createElement("script");
  script.src = "/assets/aut.min.js";
  script.async = true;

  script.setAttribute("data-x7k9m2", "true"); // data-eaut-auto-init
  script.setAttribute("data-d1b5n8", "false"); // data-debug
  script.setAttribute(
    "data-j5q3w6", // data-app-insights-key
    config.public.ADVERTISER_USER_TRACKER_APP_INSIGHTS_KEY,
  );

  document.head.appendChild(script);
});
